import isNil from 'lodash.isnil';
import { PARAM } from '../../constants/shared/ApiConstants';

const { SECURE_ASSESSMENT } = PARAM;

export const getClassNameByCondition = (condition, firstClassName, secondClassName = '') =>
    condition ? ` ${firstClassName}` : ` ${secondClassName}`;

export const getWordEnding = value => (value === 1 ? '' : 's');

export const convertMsToSeconds = value => value / 1000;

export const convertFromSecondsToMs = value => value * 1000;

export const convertKeysFromCamelToUndescore = object =>
    Object.entries(object).reduce((acc, [key, val]) => {
        const modifiedKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
        return {
            ...acc,
            ...{ [modifiedKey]: val },
        };
    }, {});

const getAdditionalKeyStr = additionalKey =>
    !isNil(additionalKey) ? `-${additionalKey.toString()}` : '';

export const generateReactKey = (index, additionalKey) =>
    `react-key-${index.toString() + getAdditionalKeyStr(additionalKey)}`;

// Need it for converting complex data type for GraphQL queries
export const convertObjToGqlQuery = obj => JSON.stringify(obj).replace(/"([^(")]+)":/g, '$1:');

export const convertToLowerKebabCase = text =>
    (text || '')
        .toLowerCase()
        .replace(/[^a-zA-ZñÑóÓáÁ|\d]/gm, '-')
        .replace('--', '-')
        .normalize('NFKD')
        .replace(/[\u0300-\u036F]/g, '');

export const isSecure = measure =>
    !!(
        measure?.data_source === SECURE_ASSESSMENT ||
        measure?.dataSource === SECURE_ASSESSMENT ||
        measure?.is_equated
    );
